module.exports = __webpack_public_path__ + "img/jf.17a25477.png";